import { getUsersForAiPage } from '../../util/api';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const AI_PAGE_USERS_REQUEST = 'app/AiLandingPage/AI_PAGE_USERS_REQUEST';
export const AI_PAGE_USERS_SUCCESS = 'app/AiLandingPage/AI_PAGE_USERS_SUCCESS';
export const AI_PAGE_USERS_ERROR = 'app/AiLandingPage/AI_PAGE_USERS_ERROR';

// ================ Reducer ================ //

const initialState = {
  usersAtAiPage: [],
  fetchUsersInProgress: false,
  fetchUsersError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case AI_PAGE_USERS_REQUEST:
      return { ...state, fetchUsersInProgress: true, fetchUsersError: null };
    case AI_PAGE_USERS_SUCCESS:
      return { ...state, fetchUsersInProgress: false, usersAtAiPage: payload };
    case AI_PAGE_USERS_ERROR:
      return { ...state, fetchUsersInProgress: false, fetchUsersError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchUsersRequest = () => ({ type: AI_PAGE_USERS_REQUEST });

export const fetchUsersSuccess = users => ({
  type: AI_PAGE_USERS_SUCCESS,
  payload: users,
});

export const fetchUsersError = error => ({
  type: AI_PAGE_USERS_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

// Users are kept in this page-specific slice as plain objects instead of
// dispatching them to the marketplaceData entity store: the sparse response
// would replace fuller user entities fetched elsewhere (attributes are not
// deep-merged, see combinedResourceObjects in util/data.js).
export const loadData = () => dispatch => {
  dispatch(fetchUsersRequest());

  return getUsersForAiPage()
    .then(response => {
      const users = response?.data || [];
      const included = response?.included || [];

      const imagesById = included.reduce((byId, entity) => {
        if (entity.type === 'image' && entity.id?.uuid) {
          byId[entity.id.uuid] = entity;
        }
        return byId;
      }, {});

      const usersWithImages = users.map(user => {
        const imageId = user.relationships?.profileImage?.data?.id?.uuid;
        const profileImage = imageId ? imagesById[imageId] : null;
        return { ...user, profileImage };
      });

      dispatch(fetchUsersSuccess(usersWithImages));
    })
    .catch(e => dispatch(fetchUsersError(storableError(e))));
};
